import { IRCConnectionSettings } from '#/types/types';
import { DEFAULT_CHANNELS, DEFAULT_NICKNAME, DEFAULT_SERVER_IP, DEFAULT_SERVER_PORT } from '#/constants';

const SETTINGS_KEY = 'irc-client-settings';

export function loadSettings(): IRCConnectionSettings {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (stored) {
        try {
            const parsed = JSON.parse(stored);
            return {
                server: parsed.server || DEFAULT_SERVER_IP,
                port: parsed.port || DEFAULT_SERVER_PORT,
                nickname: parsed.nickname || DEFAULT_NICKNAME,
                channels: parsed.channels || DEFAULT_CHANNELS.split(',').map((c: string) => c.trim()),
                nickservPassword: parsed.nickservPassword || ''

            };
        } catch (e) {
            console.warn('Failed to parse stored settings, using defaults');
        }
    }
    return {
        server: DEFAULT_SERVER_IP,
        port: DEFAULT_SERVER_PORT,
        nickname: DEFAULT_NICKNAME,
        channels: DEFAULT_CHANNELS.split(',').map(c => c.trim()),
        nickservPassword: ''
    };
}

export function saveSettings(settings: IRCConnectionSettings): void {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}

export function updateNickname(nickname: string): void {
    const settings = loadSettings();
    settings.nickname = nickname;
    saveSettings(settings);
}